var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.carts.length
      ? _c(
          "div",
          _vm._l(_vm.carts, function(cart) {
            return _c("cart-item", {
              key: cart.id,
              attrs: {
                corporation: _vm.corporation,
                cart: cart,
                permissions: _vm.permissions
              }
            })
          }),
          1
        )
      : _c("div", [
          _c("div", { staticClass: "placeholder" }, [
            _c("p", [
              _vm._v(_vm._s(_vm.$l10n.__("Aucun panier pour ce compte")))
            ])
          ])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }